export default "__VITE_ASSET__KPIHcZB___"